/**
 * This file holds "global" z-indexes.
 * Global z-index means that any elements should respect it (like popover should cover everything).
 * Local z-indexes (- 1, 0 or -1) used to define elements stack on that component's scope ONLY.
 * Global z-indexes starts from 9 to avoid colliding with local ones.
 */
export var zIndex = {
  tableStickyCell: 2,
  header: 2,
  appBar: 11,
  sidebarInactive: 12,
  sidebarActive: 13,
  watermark: 14,
  modalOverlay: 15,
  popover: 16,
  dropdown: 17,
  snackbar: 18,
  accessibility: 19
};